module.exports = __webpack_public_path__ + "img/arabian_ranches.c4a51a0.svg";